<div class="row">
    <div class="col-xl-6">
        <div class="card card-box mb-5">
            <div class="card-header bg-light">
                <div class="card-header--title">
                    <small class="d-block text-uppercase mt-1">Progress</small>
                    <b>Users Analytics</b></div>
                <div class="card-header--actions">
                    <div class="badge badge-pill badge-dark"> Pending</div>
                </div>
            </div>
            <ul class="list-group list-group-flush">
                <li class="list-group-item py-3">
                    <div class="row no-gutters">
                        <div class="col-xl-6 d-flex align-items-center col-md-12">
                            <div class="d-flex align-items-center">
                                <div class="avatar-icon-wrapper mr-2">
                                    <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar2.jpg"/></div>
                                </div>
                                <div>
                                    <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                        Shanelle Wynn
                                    </a>
                                    <span class="text-black-50 d-block">UI Engineer, Apple Inc.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 pt-3 pt-xl-0 d-flex align-items-center col-md-12">
                            <div class="align-box-row flex-grow-1">
                                <div class="d-flex flex-column flex-grow-1">
                                    <div class="d-flex justify-content-between text-dark">

                                        <div class="ml-auto">
                                            <div [countUp]="583" class="font-weight-bold"></div>
                                        </div>
                                    </div>
                                    <progressbar [animate]="true" [value]="52"
                                                 class="progress-bar-rounded progress-sm"
                                                 type="primary">
                                    </progressbar>
                                </div>
                                <button class="btn btn-sm btn-neutral-primary ml-4" type="button">View</button>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="list-group-item py-3">
                    <div class="row no-gutters">
                        <div class="col-xl-6 d-flex align-items-center col-md-12">
                            <div class="d-flex align-items-center">
                                <div class="avatar-icon-wrapper mr-2">
                                    <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar3.jpg"/></div>
                                </div>
                                <div>
                                    <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                        Akeem Griffith
                                    </a>
                                    <span class="text-black-50 d-block">Manager, Google Inc.</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 pt-3 pt-xl-0 d-flex align-items-center col-md-12">
                            <div class="align-box-row flex-grow-1">
                                <div class="d-flex flex-column flex-grow-1">
                                    <div class="d-flex justify-content-between text-dark">

                                        <div class="ml-auto">
                                            <div [countUp]="340" class="font-weight-bold"></div>
                                        </div>
                                    </div>
                                    <progressbar [animate]="true" [value]="38"
                                                 class="progress-bar-rounded progress-sm"
                                                 type="danger">
                                    </progressbar>
                                </div>
                                <button class="btn btn-sm btn-neutral-danger ml-4" type="button">View</button>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="list-group-item py-3">
                    <div class="row no-gutters">
                        <div class="col-xl-6 d-flex align-items-center col-md-12">
                            <div class="d-flex align-items-center">
                                <div class="avatar-icon-wrapper mr-2">
                                    <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar4.jpg"/></div>
                                </div>
                                <div>
                                    <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                        Abigayle Hicks
                                    </a>
                                    <span class="text-black-50 d-block">Project Manager, Spotify</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 pt-3 pt-xl-0 d-flex align-items-center col-md-12">
                            <div class="align-box-row flex-grow-1">
                                <div class="d-flex flex-column flex-grow-1">
                                    <div class="d-flex justify-content-between text-dark">

                                        <div class="ml-auto">
                                            <div [countUp]="473" class="font-weight-bold"></div>
                                        </div>
                                    </div>
                                    <progressbar [animate]="true" [value]="34"
                                                 class="progress-bar-rounded progress-sm"
                                                 type="warning">
                                    </progressbar>
                                </div>
                                <button class="btn btn-sm btn-neutral-warning ml-4" type="button">View</button>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="list-group-item py-3">
                    <div class="row no-gutters">
                        <div class="col-xl-6 d-flex align-items-center col-md-12">
                            <div class="d-flex align-items-center">
                                <div class="avatar-icon-wrapper mr-2">
                                    <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar5.jpg"/></div>
                                </div>
                                <div>
                                    <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                        Tyrell Macleod
                                    </a>
                                    <span class="text-black-50 d-block">DevOps, Netflix</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 pt-3 pt-xl-0 d-flex align-items-center col-md-12">
                            <div class="align-box-row flex-grow-1">
                                <div class="d-flex flex-column flex-grow-1">
                                    <div class="d-flex justify-content-between text-dark">

                                        <div class="ml-auto">
                                            <div [countUp]="836" class="font-weight-bold"></div>
                                        </div>
                                    </div>
                                    <progressbar [animate]="true" [value]="83"
                                                 class="progress-bar-rounded progress-sm"
                                                 type="first">
                                    </progressbar>
                                </div>
                                <button class="btn btn-sm btn-neutral-first ml-4" type="button">View</button>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="list-group-item py-3">
                    <div class="row no-gutters">
                        <div class="col-xl-6 d-flex align-items-center col-md-12">
                            <div class="d-flex align-items-center">
                                <div class="avatar-icon-wrapper mr-2">
                                    <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar1.jpg"/></div>
                                </div>
                                <div>
                                    <a [routerLink]="" class="font-weight-bold text-black" title="...">
                                        Huw Conley
                                    </a>
                                    <span class="text-black-50 d-block">Manager, Dribbble</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6 pt-3 pt-xl-0 d-flex align-items-center col-md-12">
                            <div class="align-box-row flex-grow-1">
                                <div class="d-flex flex-column flex-grow-1">
                                    <div class="d-flex justify-content-between text-dark">

                                        <div class="ml-auto">
                                            <div [countUp]="236" class="font-weight-bold"></div>
                                        </div>
                                    </div>
                                    <progressbar [animate]="true" [value]="62"
                                                 class="progress-bar-rounded progress-sm"
                                                 type="success">
                                    </progressbar>
                                </div>
                                <button class="btn btn-sm btn-neutral-success ml-4" type="button">View</button>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col-xl-6">
        <div class="card mb-5">
            <div class="card-header-alt d-flex justify-content-between p-4">
                <div>
                    <h6 class="font-weight-bold font-size-lg mb-1 text-black">Weekly Sales</h6>
                    <p class="text-black-50 mb-0">Reports for what we sold this week.</p>
                </div>
                <div class="d-flex align-items-center">
                    <div class="btn-group" dropdown placement="bottom right">
                        <button class="btn btn-link btn-link-second p-0 font-size-xl text-second dropdown-toggle no-caret"
                                dropdownToggle
                                type="button">
                            <fa-icon [icon]="['fas', 'ellipsis-h']" class="font-size-lg"></fa-icon>
                        </button>
                        <div *dropdownMenu
                             class="dropdown-menu dropdown-menu-right dropdown-menu-xxl overflow-hidden p-0">
                            <div class="grid-menu grid-menu-2col">
                                <div class="no-gutters row">
                                    <div class="col-sm-6">
                                        <button class="btn border-0 w-100 btn-transition-none rounded-0 shadow-none btn-outline-gray py-4 px-1"
                                                type="button">
                                            <fa-icon [icon]="['far', 'bell']"
                                                     class="h2 d-block mb-2 mt-1 text-first"></fa-icon>
                                            <div class="font-weight-bold text-black">Reports</div>
                                            <div class="font-size-md mb-1 text-black-50">Monthly Stats</div>
                                        </button>
                                    </div>
                                    <div class="col-sm-6">
                                        <button class="btn border-0 w-100 btn-transition-none rounded-0 shadow-none btn-outline-gray py-4 px-1"
                                                type="button">
                                            <fa-icon [icon]="['far', 'file-excel']"
                                                     class="h2 d-block mb-2 mt-1 text-first"></fa-icon>
                                            <div class="font-weight-bold text-black">Statistics</div>
                                            <div class="font-size-md mb-1 text-black-50">Customers stats</div>
                                        </button>
                                    </div>
                                    <div class="col-sm-6">
                                        <button class="btn border-0 w-100 btn-transition-none rounded-0 shadow-none btn-outline-gray py-4 px-1"
                                                type="button">
                                            <fa-icon [icon]="['far', 'eye']"
                                                     class="h2 d-block mb-2 mt-1 text-first"></fa-icon>
                                            <div class="font-weight-bold text-black">Projects</div>
                                            <div class="font-size-md mb-1 text-black-50">Manage servers</div>
                                        </button>
                                    </div>
                                    <div class="col-sm-6">
                                        <button class="btn border-0 w-100 btn-transition-none rounded-0 shadow-none btn-outline-gray py-4 px-1"
                                                type="button">
                                            <fa-icon [icon]="['far', 'chart-bar']"
                                                     class="h2 d-block mb-2 mt-1 text-first"></fa-icon>
                                            <div class="font-weight-bold text-black">Tasks</div>
                                            <div class="font-size-md mb-1 text-black-50">Pending items</div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mx-4 divider"></div>
            <div class="mx-4 divider"></div>
            <div class="px-5 pt-5 pb-3">
                <h1 class="display-2 font-weight-bold mb-5">
                    $
                    <span [countUp]="477693"></span>
                </h1>
                <div class="row">
                    <div class="col">
                        <div>
                            <span class="font-size-xl font-weight-bold">76%</span>
                        </div>
                        <progressbar [value]="76" class="progress-bar-rounded progress-sm mb-2"
                                     type="success"></progressbar>
                        <div class="text-dark">
                            Orders
                        </div>
                    </div>
                    <div class="col">
                        <div>
                            <span class="font-size-xl font-weight-bold">34%</span>
                        </div>
                        <progressbar [value]="34" class="progress-bar-rounded progress-sm mb-2"
                                     type="danger"></progressbar>
                        <div class="text-dark">
                            Deliveries
                        </div>
                    </div>
                    <div class="col">
                        <div>
                            <span class="font-size-xl font-weight-bold">49%</span>
                        </div>
                        <progressbar [value]="49" class="progress-bar-rounded progress-sm mb-2"
                                     type="warning"></progressbar>
                        <div class="text-dark">
                            Products
                        </div>
                    </div>
                </div>
            </div>
            <apx-chart
                    [chart]="{
                        type: 'area',
                        height: '80',
                        sparkline: {
                          enabled: true
                        }
                    }"
                    [colors]="['#1bc943']"
                    [fill]="{
                        color: '#1bc943',
                        gradient: {
                            shade: 'light',
                            type: 'vertical',
                            shadeIntensity: 0.3,
                            inverseColors: false,
                            opacityFrom: 1,
                            opacityTo: 0,
                            stops: [0, 100]
                        }
                    }"
                    [series]="[
                      {
                        name: 'Weekly sales',
                        data: [47, 38, 56, 24, 45, 54, 38, 56, 24, 65]
                      }
                    ]"
                    [stroke]="{
                        color: '#4191ff',
                        curve: 'smooth',
                        width: 2
                    }"
                    [xaxis]="{
                        crosshairs: {
                            width: 1
                        }
                    }"
                    [yaxis]="{
                        min: 0
                    }"
            ></apx-chart>
            <div class="card-footer p-3 text-center">
                <button class="btn btn-sm btn-outline-second" type="button">
                    <span class="btn-wrapper--label">
                        View complete report
                    </span>
                    <span class="btn-wrapper--icon">
                        <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>
